// extracted by mini-css-extract-plugin
export default {"recordManualPassageUnknownError":"recordManualPassageUnknownError-To2ya"};